import React, { useEffect, useState } from "react";
import styles from "./SelectButton.module.css";
import {
  $fontWeightNormal,
  $primaryColors,
  Flex
} from "@acko-tech/building-blocks.ui.common";
import StyledSelect, { Container } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { setPayloadData } from "@store/slices/globalState";
import {
  getWidgetSpecificIsVisible,
  updateStateBasedOnFieldChange
} from "@utils/index";

import { connect } from "react-redux";
import { updateNormalisedConfig } from "@store/slices/config";
import { store } from "@store/store";
import { setAnalytics } from "@actions/setAnalyticsData";
import { useOnload } from "@utils/useOnLoad";
import { FormatCTAtext } from "@components/mmvNotFoundModal";
import DOMPurify from "isomorphic-dompurify";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const SelectButton = (props: any) => {
  const dispatch = useDispatch();

  const {
    label,
    option,
    onSelect,
    is_visible,
    actions,
    value,
    payloadData,
    parentId,
    preSelectedValue,
    styles,
    formatCtaStyles,
    recommended_tag,
    multi_tenure_recommended_tag,
    discount,
    tagStyles,
    width = "100%"
  } = props || {};
  const { on_click } = actions || [];

  const { selectedOption } = useSelector(({ globalState }: any) => {
    return {
      selectedOption: globalState?.payloadData?.[payloadData?.name]
    };
  });

  const { on_load } = actions || {};

  useOnload({ on_load });

  const onValueUpdate = () => {
    // updateStateBasedOnFieldChange(parentId);
    dispatch(
      setPayloadData({
        [payloadData?.name]: value
      })
    );
    setAnalytics({
      [payloadData?.name]: value
    });
  };

  useEffect(() => {
    if (
      parentId === "add_edit_cng_is_external_cng_qna" &&
      preSelectedValue !== undefined &&
      selectedOption === undefined
    ) {
      if (value === preSelectedValue) {
        onValueUpdate();
      }
    } else if (value === selectedOption) {
      onValueUpdate();
    }
  }, [selectedOption, value, preSelectedValue, parentId]);

  const handleClick = () => {
    // const { configuration } = store.getState() || {};
    // const { normalisedConfig } = configuration || {}
    // const updatedNormalisedConfig = JSON.parse(
    //   JSON.stringify(normalisedConfig),
    // );
    // const data = updatedNormalisedConfig[parentId];
    // data.props.error_message = '';
    // dispatch(updateNormalisedConfig({
    //   normalisedConfig: updatedNormalisedConfig,
    // }));

    onValueUpdate();

    on_click?.forEach((action) => {
      if (action && typeof action.funCall === "function") {
        action.funCall(action.args || {});
      }
    });
  };

  const getRecommendedTag = () => {
    if (multi_tenure_recommended_tag && discount > 30) {
      return multi_tenure_recommended_tag;
    }
    return recommended_tag;
  };
  const recommendedTagToShow = getRecommendedTag();

  return is_visible ? (
    <Flex width={width} style={{ position: "relative" }}>
      {recommendedTagToShow && (
        <div
          style={{
            position: "absolute",
            background:
              "linear-gradient(269deg, #F66969 -10.35%, #743DDC 106.34%)",
            color: "#fff",
            fontSize: "10px",
            fontWeight: "500",
            padding: "2px 8px",
            borderTopLeftRadius: "12px",
            borderBottomRightRadius: "12px",
            zIndex: 1,
            ...(tagStyles || {})
          }}
        >
          {recommendedTagToShow}
        </div>
      )}
      <StyledSelect
        selected={value === selectedOption || (parentId === "add_edit_cng_is_external_cng_qna" && value === preSelectedValue && selectedOption === undefined)}
        handleClick={handleClick}
        key={label}
        hideSelectIcon
        value={label?.toString()}
        theme={{
          primaryColor: $primaryColors,
          normalWeight: $fontWeightNormal
        }}
        styles={styles}
      >
        <FormatCTAtext
          style={{ color: "#040222", ...formatCtaStyles }}
          htmlContent={DOMPurify.sanitize(label)}
        />
      </StyledSelect>
    </Flex>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(SelectButton);
